// Dependency import
import { APIGetCountryAndStateFullNames } from "../_api-get-country-and-state-full-names";
import { GetUTMParams }                   from "../_get-utm-params";
import { ZerobounceValidateEmail }        from "../_zerobounce-validate-email";

// Elements
const FORM = ".js-popup-test-drive-form";
const THANK_YOU = "#test-drive-finally";
const SUBMIT = ".js-popup-test-drive-form-submit";
const PRELOADER = ".js-popup-test-drive-form-preloader";
const CLASSNAME_PRELOADER = "is-loading";

// Validation options
const VALIDATION_OPTIONS = {
	fields: {
		"name": {
			validators: {
				notEmpty: {
					message: "Please enter your first name"
				}
			}
		},
		"email": {
			validators: {
				notEmpty: {
					message: "Please enter your email address"
				},
				emailAddress: {
					message: "Your email address should look like that John@example.com"
				},
				remote: {
					message: "Please enter an active email address"
				}
			}
		}
	},
	plugins: {
		message: new FormValidation.plugins.Message( {
			clazz: "form-error",
			container: function ( field, element ) {
				return element.closest( ".form-control" );
			}
		} ),
		trigger: new FormValidation.plugins.Trigger()
	}
};

/**
 * Formhandler
 * 
 * @emits "testdriveformsubmitted" after successful sending to mailchimp of form data
 */
function testDrive() {

	if ( ! document.querySelector( FORM ) ) {
		return;
	}

	const form = document.querySelector( FORM );

	let fv = FormValidation
		.formValidation( form, VALIDATION_OPTIONS );

	fv.disableValidator( "email", "remote" );

	const submit = form.querySelector( SUBMIT );
	submit.addEventListener( "click", function ( event ) {
		event.preventDefault();

		fv.validate().then( function ( status ) {
			if ( status === "Valid" ) {

				$( PRELOADER ).addClass( CLASSNAME_PRELOADER );

				let data = $( FORM ).serialize();

				// Add UTM parameters from string
				data += GetUTMParams();

				// Get user country and state
				APIGetCountryAndStateFullNames( false, false, function ( location ) {

					if ( location != "error" ) {
						data += "&country=" + location.countryName;
						if ( "US" === location.country ) {
							data += "&state=" + location.stateName;
						} else {
							data += "&state=";
						}
					}

					let urlParams = new URLSearchParams( data );

					let unserializedData = {};
					for ( let [ key, value ] of urlParams ) {
						if ( unserializedData.hasOwnProperty( key ) ) {
							unserializedData[ key ] += ", " + value;
						} else {
							unserializedData[ key ] = value;
						}
					}

					// ZeroBounce API check
					ZerobounceValidateEmail( FORM + " input[name='email']", function ( response ) {
						if ( response.status === "invalid" ) {
							fv.updateFieldStatus( "email", "Invalid", "remote" );
							$( PRELOADER ).removeClass( CLASSNAME_PRELOADER );
						} else {

							unserializedData.zero_bounce_status = response.status;

							jQuery.ajax( {
								url: gocoderzAjax.url,
								type: "post",
								data: {
									action: "mailchimp_test_drive_form_submit",
									nonce: gocoderzAjax.nonce,
									formData: unserializedData
								},
								success: function ( result ) {
									if ( result == "success" ) {
										$( PRELOADER ).removeClass( CLASSNAME_PRELOADER );
										$.fancybox.close( $( "#test-drive" ) );
										$.fancybox.open( $( THANK_YOU ), {
											hideScrollbar: true
										} );
										const testdriveformsubmitted = new CustomEvent( "testdriveformsubmitted" );
										document.dispatchEvent( testdriveformsubmitted );
										RedirectToLPTestDrive();
									} else {
										let data = JSON.parse( result );
										for ( let i = 0; i < data.length; i++ ) {
											const error = data[ i ];
											let field = error.field;
											if ( field == "email_address" ) {
												fv.updateFieldStatus( "email", "Invalid", "remote" );
												$( PRELOADER )
													.removeClass( CLASSNAME_PRELOADER );
											}
										}
									}
								},
								error: function ( error ) {
									$( PRELOADER ).removeClass( CLASSNAME_PRELOADER );
									$.fancybox.close( $( "#test-drive" ) );
									$.fancybox.open( $( THANK_YOU ), {
										hideScrollbar: true
									} );
									RedirectToLPTestDrive();
								}
							} );
						}
					} );
				} );
			}
		} );
	} );
}

/**
 * @description Redirect user after 3 seconds to https://play.gocoderz.com/lp/test-drive/ depends on hostname
 */
function RedirectToLPTestDrive() {
	let hostname = window.location.hostname,
		protocol = window.location.protocol;

	setTimeout( () => {
		window.location = `${ protocol }//play.${ hostname }/lp/test-drive/`;
	}, 3000 );
}

export { testDrive };